
import { NgModule } from '@angular/core';
import { VideoProviderListComponent } from './video-provider-list/video-provider-list.component';
import { VideoProviderEditComponent } from './video-provider-edit/video-provider-edit.component';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    VideoProviderListComponent,
    VideoProviderEditComponent],
})
export class VideoProviderModule { }
